/* eslint-disable @typescript-eslint/ban-ts-comment */
'use client';
// import { AppsFlyers } from '@spot-fe/app-bridge';
import { isSupportLocale } from '@spot-fe/utils';
import { useUserInfo } from '../provider';
import { LayoutContainerProps } from './container';
import { AdaBot } from '../ada';
// import { getJsBridgeCdn, getUniFrameCdn } from '../cdn';
import { Footer as RenderFooter } from '../footer';
import { Header as RenderHeader } from '../header';
import { getUniFrameCdn } from './header';
import Script from 'next/script';
import SensorsScript from '../sensors-script';
import { useEffect, useState } from 'react';

interface Props extends LayoutContainerProps {
  locales: string[];
  ignoreLocalConfig?: boolean;
}

const getFullPath = (locale: string) => {
  const pathname = window.location.pathname.replace(/[&<>"']/g, '');
  const path = `${pathname}${window.location.search}${window.location.hash}`;
  const paths = path
    .replace(/^[\\/]+/, '') // 过滤开头的 / ，用来做路径分隔。过滤转义符，防止外链接钓鱼
    .split(/\/+/); // 以 / 分隔来取 lang

  // 如果一级是语言，则删除
  if (isSupportLocale(paths[0])) {
    paths.splice(0, 1);
  }

  // 处理多语言前缀
  return isSupportLocale(locale)
    ? `/${locale}/${paths.join('/')}`
    : `/${paths.join('/')}`;
};
const onLanguageChange = (newLocale: string) => {
  window.location.href = getFullPath(newLocale);
};

export function Body({
  locale,
  locales,
  children,
  hasLoadUniFrame,
  hasLoadJsBridge,
  hasRenderHeader,
  hasRenderFooter,
  hasLoadAppsFlyers,
  hasLoadAdaBot,
  ignoreLocalConfig,
  env,
  ...props
}: Props) {
  const { userInfo } = useUserInfo();
  const [uniframeHasReady, setUniframeHasReady] = useState(false);
  console.log('!!!!!', userInfo);

  // useEffect(() => {
  //   hasLoadJsBridge && injectDeepLink();
  // }, [hasLoadJsBridge]);

  useEffect(() => {
    // 这段代码只在客户端渲染后执行
    if(!hasLoadUniFrame) return;
    const script = document.createElement('script');
    script.src = getUniFrameCdn(env.BASE_ENV);
    script.async = true;
    script.onload = () => {
      setUniframeHasReady(true);
    };
    document.body.appendChild(script);

    // 清理脚本
    return () => {
        document.body.removeChild(script);
    };
}, [hasLoadUniFrame]);


  return (
    <>
      {/* APP中保留uniframe基础功能，是为了全局合规墙的功能*/}
      {/* {hasLoadUniFrame && (
          <Script
            src={getUniFrameCdn(env.BASE_ENV)}
            strategy="beforeInteractive"
          />
      )} */}
      {/* {hasLoadJsBridge && <script src={getJsBridgeCdn()} />} */}
      {hasLoadUniFrame && hasRenderHeader && (
        <RenderHeader
          locale={locale}
          locales={locales}
          userInfo={userInfo}
          onLanguageChange={onLanguageChange}
          uniframeHasReady={uniframeHasReady}
        />
      )}
      <SensorsScript projectName={props.projectName} />
      {children}
      {hasLoadUniFrame && hasRenderFooter && <RenderFooter locale={locale} uniframeHasReady={uniframeHasReady}/>}
      {hasLoadUniFrame && hasLoadAdaBot && (
        <AdaBot locale={locale} userInfo={userInfo} uniframeHasReady={uniframeHasReady}/>
      )}
      {/* 默认不展示顶部下载bar */}
      {/* {hasLoadAppsFlyers && <AppsFlyers />} */}
    </>
  );
}
